import * as tslib_1 from "tslib";
import React from 'react';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';
import { BiDiv } from '../biLogger';
import ElementQueries from '../ElementQueries';
import Button from '../Button';
import TextTooltipOnHover from '../Tooltip/TextTooltipOnHover';
import LockIcon from '../Icons/Lock';
import SubfoldersIcon from '../Icons/Subfolders';
import ContainerSize from '../ContainerSize';
import DeviationDumbView from '../DeviationViews/Dumbo';
import FolderLink from './FolderLink';
import s from './FolderCard.scss';
import { IconSize } from '../Icons/IconWrap';
import ErrorBoundary from '../ErrorBoundary';
var LIST_VIEW_PREVIEW_WIDTH = 230;
var LIST_VIEW_PREVIEW_HEIGHT = 129;
var FolderCard = /** @class */ (function (_super) {
    tslib_1.__extends(FolderCard, _super);
    function FolderCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderCardContent = function () {
            var _a = _this.props, folder = _a.folder, subfolders = _a.subfolders, extras = _a.extras, isLocked = _a.isLocked, isSelected = _a.isSelected, t = _a.t, withViewAllButton = _a.withViewAllButton, withCommentsCount = _a.withCommentsCount, statsClassName = _a.statsClassName, onClick = _a.onClick, contentClickBiData = _a.contentClickBiData;
            var hasSubfolders = subfolders && subfolders.length;
            var totalDeviationCount = folder.size +
                (subfolders
                    ? subfolders.reduce(function (prevValue, subfolder) { return prevValue + subfolder.size; }, 0)
                    : 0);
            return (React.createElement(BiDiv, { className: classnames(s['content'], isSelected && s['selected']), onClick: onClick, biData: contentClickBiData },
                React.createElement(ContainerSize, { className: s['preview-container'] }, function (_a) {
                    var width = _a.width, height = _a.height;
                    return (React.createElement(React.Fragment, null,
                        hasSubfolders && (React.createElement(SubfoldersIcon, { className: s['subfolders-icon'] })),
                        _this.renderDeviationDumbView({ width: width, height: height })));
                }),
                React.createElement("div", { className: s['bottom-content'] },
                    React.createElement("div", { className: s['description'] },
                        React.createElement("div", { className: s['name'] },
                            React.createElement("span", null, folder.name),
                            isLocked && (React.createElement(TextTooltipOnHover, { className: s['lock-icon'], tooltipText: t('folderCard.locked'), positionFixed: true, width: 220 },
                                React.createElement(LockIcon, { size: IconSize.MEDIUM, condensed: true })))),
                        React.createElement("div", { className: classnames(s['stats'], statsClassName) },
                            React.createElement("div", { className: s['artworks-count'] }, t('folderCard.stats.artworks', {
                                count: totalDeviationCount,
                            })),
                            withCommentsCount && (React.createElement("div", { className: s['comments-count'] }, t('folderCard.stats.comments', {
                                count: folder.commentCount,
                            }))))),
                    withViewAllButton && (React.createElement(Button, { view: "b14", height: "medium", className: s['view-all'] }, t('folderCard.viewAll'))),
                    React.createElement("span", { className: s['extras'], onClick: _this.onExtrasClick }, extras))));
        };
        _this.renderDeviationDumbView = function (_a) {
            var width = _a.width, height = _a.height;
            var thumb = _this.props.folder.thumb;
            if (!width || !height) {
                return null;
            }
            if (!thumb) {
                return React.createElement("div", { className: s['preview'], style: { width: width, height: height } });
            }
            return (React.createElement(DeviationDumbView, { className: s['preview'], width: width || LIST_VIEW_PREVIEW_WIDTH, height: height || LIST_VIEW_PREVIEW_HEIGHT, deviation: thumb }));
        };
        return _this;
    }
    FolderCard.prototype.render = function () {
        var _a = this.props, folder = _a.folder, className = _a.className, onClick = _a.onClick, withLink = _a.withLink, withShadow = _a.withShadow;
        var preventDefault = function (e) { return !e.metaKey && !e.ctrlKey && e.preventDefault(); };
        return (React.createElement(ErrorBoundary, null,
            React.createElement(ElementQueries, { widthBreakpoints: [130, 220, 300, 999], className: classnames(s['root'], withShadow && s['with-shadow'], onClick && s['clickable'], className) }, withLink ? (React.createElement(FolderLink, { onClick: onClick ? preventDefault : undefined, folder: folder }, this.renderCardContent())) : (this.renderCardContent()))));
    };
    FolderCard.prototype.onExtrasClick = function (event) {
        event.stopPropagation();
    };
    FolderCard.defaultProps = {
        showCommentsCount: true,
        withLink: true,
    };
    return FolderCard;
}(React.Component));
export { FolderCard };
export default withTranslation()(FolderCard);
//# sourceMappingURL=FolderCard.js.map